import type { Space } from '@/features/spaces/interfaces/space.interface';

export interface CurrentSpaceState {
  /** The full current Space object. Undefined until a space is selected. */
  currentSpace: Space | undefined;
  /** The ID of the current space, extracted automatically on setCurrentSpace(space). */
  currentSpaceId: string | undefined;
}

export const initialCurrentSpaceState: CurrentSpaceState = {
  currentSpace: undefined,
  currentSpaceId: undefined,
};
